import { ComponentProps, KeyboardEvent } from 'react'

import { type KeywordSearchHistory } from '../../model/keyword-search-history-store/history'
import { KeywordList } from '../keyword-list/index.pc'
import { Popup } from '../popup/popup'
import { RecentRoomList } from '../recent-room-list/index.pc'
import { SearchHistoryList } from '../search-history-list/keyword.pc'

type Props = ComponentProps<typeof Popup> & {
  onItemClick: (history: KeywordSearchHistory) => void
  onRecommendKeywordClick: (keyword: string) => void
  onClose: () => void
}

export const KeywordSearchHistoryPopup = ({
  onItemClick,
  onRecommendKeywordClick,
  onClose,
  ...restProps
}: Props) => {
  const handleOpenAutoFocus = (event: Event) => {
    event.preventDefault()
  }

  const handleKeyDown = (event: KeyboardEvent) => {
    event.preventDefault()

    switch (event.key) {
      case 'Escape': {
        onClose()
        break
      }
    }
  }

  return (
    <Popup
      className="flex h-fit min-h-[564px] w-[800px] overflow-hidden rounded-xl"
      onOpenAutoFocus={handleOpenAutoFocus}
      onKeyDown={handleKeyDown}
      autoFocus={true}
      {...restProps}
    >
      <div className="flex w-[400px] shrink-0 flex-col border-r border-gray-100">
        <KeywordList onClick={onRecommendKeywordClick} />
        <SearchHistoryList onItemClick={onItemClick} />
      </div>
      <RecentRoomList />
    </Popup>
  )
}
